import { render, staticRenderFns } from "./AmountMenu.vue?vue&type=template&id=40676f0c&scoped=true&"
import script from "./AmountMenu.vue?vue&type=script&lang=ts&"
export * from "./AmountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AmountMenu.vue?vue&type=style&index=0&id=40676f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40676f0c",
  null
  
)

export default component.exports